  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"   
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "InstrutorPdf",
        components: {  CardRh  },   
    }) 
    export default class InstrutorPdf extends Vue {  
        
        @authStore.Getter
		public token!: any 

        @Prop( ) readonly dados!: any   
        @Prop( ) readonly modal!: any  
        
        public service = new InstrutorService();
        public identificador = 1 ;   
        public url: any = ""; 

        @Watch('dados')
		dadosAtualizado(newVal: string) {  
            this.gerarRelatorio();
		} 
  
        public gerarRelatorio(){
            this.url =   null; 
            if(this.dados != null ){
                setTimeout(() => {
                this.url =  `${this.service.getApiUrl()}/Relatorio/Aula/Pdf?instrutorAuxiliarCPF=${this.dados.cpf}&ano=${this.dados.ano}&mes=${ this.dados.mes}&disciplinaId=${this.dados.disciplinaid}&token=${ this.token}` ;
                this.identificador++;
            }, 2 ); 
            } 
            
        }
    } 
